import { render } from "./ItemPanelTabs.vue?vue&type=template&id=75ba866e"
import script from "./ItemPanelTabs.vue?vue&type=script&lang=js"
export * from "./ItemPanelTabs.vue?vue&type=script&lang=js"

import "./ItemPanelTabs.vue?vue&type=style&index=0&id=75ba866e&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__